export const normalizeAdvertiserScopeValue = (value) =>
  String(value ?? "").trim();

export const resolveOAuthReturnAdvertiserScope = ({
  callbackAdvertiserId = "",
  sessionAdvertiserId = "",
  selectedAdvertiserId = "",
  authorizedAdvertiserId = "",
} = {}) => {
  const callbackId = normalizeAdvertiserScopeValue(callbackAdvertiserId);
  const sessionId = normalizeAdvertiserScopeValue(sessionAdvertiserId);
  const selectedId = normalizeAdvertiserScopeValue(selectedAdvertiserId);
  const authorizedId = normalizeAdvertiserScopeValue(authorizedAdvertiserId);
  const returnAdvertiserId = callbackId || sessionId;
  const callbackSessionMismatch = Boolean(
    callbackId && sessionId && callbackId !== sessionId
  );
  const verified = Boolean(
    returnAdvertiserId &&
      selectedId === returnAdvertiserId &&
      authorizedId === returnAdvertiserId &&
      !callbackSessionMismatch
  );

  return {
    returnAdvertiserId,
    callbackSessionMismatch,
    verified,
  };
};
